import axios from 'axios';
import { makeGetEnablerStateUrl, makeSetEnablerViewedUrl } from '../utils/urlProvider';

class EnablerApi {
  getEnablerState = enablerId => (
    axios({
      method: 'GET',
      url: makeGetEnablerStateUrl(enablerId),
      withCredentials: true,
    })
  );

  setEnablerViewed = enablerId => (
    axios({
      method: 'POST',
      url: makeSetEnablerViewedUrl(enablerId),
      withCredentials: true,
    })
  );
}

export default new EnablerApi();
